import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout-app/app/settings')({});
